var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47656 6.14844C7.83203 6.47656 7.83203 7.05078 7.47656 7.37891L2.22656 12.6289C1.89844 12.9844 1.32422 12.9844 0.996094 12.6289C0.640625 12.3008 0.640625 11.7266 0.996094 11.3984L5.61719 6.75L0.996094 2.12891C0.640625 1.80078 0.640625 1.22656 0.996094 0.898438C1.32422 0.542969 1.89844 0.542969 2.22656 0.898438L7.47656 6.14844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow_right.6b73737313b7e45859846720b9d8bc7c.svg";
export { ForwardRef as ReactComponent };